import { PropertiesAction, PropertiesActionType } from './properties.action';
import { Address, initialPropertiesState, PropertiesState } from './properties.state';

function setPropertyInfo(payload: any, state: PropertiesState): any {
  if (payload.length > 0) {
    return Object.assign({}, state, {
      ...state.propertyInfo,
      propertyInfo: payload[0]
    });
  } else {
    return Object.assign({}, state, {
      propertyInfo: payload
    });
  }
}

export function propertiesReducer(
  state: PropertiesState = initialPropertiesState,
  action: PropertiesAction): PropertiesState {
  switch (action.type) {

    case PropertiesActionType.SetPropertyInfo:
      return Object.assign({}, state, {
        propertyInfo: action.payload
      });

    case PropertiesActionType.SetSelectedProperty:
      return Object.assign({}, state, {
        selectedProperty: action.payload,
      });

    case PropertiesActionType.SetGeoJsonProperty:
      return Object.assign({}, state, {
        geoJson: action.payload
      });

    case PropertiesActionType.ResetGeoJsonProperty:
      return Object.assign({}, state, {
        geoJson: {},
      });

    case PropertiesActionType.SetPropertiesDbLinks:
      return Object.assign({}, state, {
        propertiesDBLink: action.payload,
      });

    case PropertiesActionType.SetPropertyBoundingBox:
      return Object.assign({}, state, {
        boundingBox: action.payload.extent,
      });

    case PropertiesActionType.SetPrintSvcConn:
      return Object.assign({}, state, {
        svcconn: action.payload,
      });

    case PropertiesActionType.SetAddressByDbLink:
      return Object.assign({}, state, {
        scAddress: action.payload,
      });

    case PropertiesActionType.SetEnerGovInfo:
      return Object.assign({}, state, {
        energovInfo: action.payload,
      });

    default:
      return state;
  }
}
